import { isDefinedString } from "et3-type-guards";
import { memoize } from "lodash";
import { observable, runInAction } from "mobx";

class ApprovalViewerStore {
  pictureSource = observable.box<string>("");

  isVisible = () => {
    return isDefinedString(this.pictureSource.get());
  };

  openPicture = (pictureSource: string) => {
    runInAction(() => {
      this.pictureSource.set(pictureSource);
    });
  };

  closePicture = () => {
    runInAction(() => {
      this.pictureSource.set("");
    });
  };
}

const getApprovalViewerStore = memoize(
  () => new ApprovalViewerStore(),
  () => 1
);
export default getApprovalViewerStore;
